// Use like so:
//
//  %div{data: {controller: "niappstructure--graphviz", niappstructure__graphviz_dot_value: "..."}}

import { Controller } from '@hotwired/stimulus'
import { instance } from "@viz-js/viz";

export default class extends Controller {
  static values = {
    dot: String
  }

  connect () {
    instance().then(viz => { this.element.replaceChildren(viz.renderSVGElement(this.dotValue)) });
  }
}
